var SelectionRange, TrelloMarkdown, _,
  slice = [].slice,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

_ = require('underscore');


/*
Adapted from https://github.com/chjj/marked/blob/master/lib/marked.js

Step 1 - Block Lexing

Take the plain text, and do "Block Lexing", breaking it up into tokens that
represent paragraphs, lists, headings, etc.  This is also the stage where we
figure out [1]: ... style link references.  Some of these blocks will have text
that needs further processing, for these we do "inline lexing".

Step 2 - Inline Lexing

Convert the text part of a block token into inline tokens.  This is where we'd
generate tokens that represent bold, italic, links, etc.

(After this step we've created a list of the locations of the locations in our
original string that match the different rules)

Step 3 - Block Parsing

Here we output the HTML representation of the block tokens.  Some of the blocks
will children (aka inline formatting)

Step 4 - Inline Parsing

Here we output the HTML representation of the inline tokens.

Notes:

  - The Block Lexing/Parsing and Inline Lexing/Parsing are very similar.  The
    lexer rules (i.e. lexerBlockRules and lexerInlineRules) contain patterns
    of text that should be converted to a token and a method that converts
    the regex capture into a token.

    For example:

    code:
      match: ///
        ^
        (
          \x20{4} # 4 spaces
          [^\n]+
          \n*
        )+
      ///
      token: ([ all ]) ->
        type: 'code'
        text: all.replace(/^ {4}/gm, '').replace(/\n+$/, '')

    ... says that a group of lines that start with 4 spaces is considered a
    match, and the token function takes the capture, and generates a token of
    type 'code'.

    The "token" functions can return

     - a single token
     - an array of tokens
     - null (no tokens)
     - false (there was a match, but we've decided to ignore that fact and
       continue trying other rules)

    All tokens have a "type" attribute, that indicates which outputter to
    use; the outputters (i.e. parseBlockRules and parseInlineRules) convert the
    tokens to HTML.  (They take the token as an argument)

    For example:

    code: ({ text }) ->
      @htmln('code', @text(text), { preTag: '<pre>', postTag: '</pre>' })

    ... takes a token with type "code", and outputs a <code> tag that contains
    the text part of the token rendered as text.  (Additionally, it puts a
    <pre> tag before and a </pre> after)

  - The order of the entries in lexerBlockRules and lexerInlineRules are
    important; e.g. you'd certainly want to figure out the code blocks before
    you tried to detect other types of formatting.  There should always be
    a match; if we get to the last rule, we throw.

  - Remember, the . behaves differently in Javascript; /./.test("\n") == false
    That's why you'll see [\s\S] being used

  - Because we've expanded many of the regexs out using ///, we can't use / +/
    to mean "an arbitrary number of space characters"
    That's why you'll see \x20* being used
 */

TrelloMarkdown = (function() {
  var _linkToken, _prepareText, parseAtMention;

  function TrelloMarkdown(options) {
    var base, ref1, ref2;
    this.options = options != null ? options : {};
    if ((base = this.options).shouldOpenLinkInNewTab == null) {
      base.shouldOpenLinkInNewTab = function(url) {
        return true;
      };
    }
    this.lexerBlockRules = this.options.inlineOnly ? [TrelloMarkdown.lexerBlockRules.error] : this._expandRules(TrelloMarkdown.lexerBlockRules, (ref1 = this.options.restrict) != null ? ref1.block : void 0);
    this.lexerInlineRules = this._expandRules(TrelloMarkdown.lexerInlineRules, (ref2 = this.options.restrict) != null ? ref2.inline : void 0);
  }

  TrelloMarkdown.prototype._expandRules = function(rules, enabledRules) {
    var compile, compiled, match, name, originalRuleNames, ref1, regexRuleName, rule, ruleName;
    originalRuleNames = _.sortBy(_.keys(rules), function(name) {
      return -name.length;
    });
    regexRuleName = RegExp("" + (originalRuleNames.join("|")), "g");
    if (enabledRules != null) {
      enabledRules = enabledRules.concat((function() {
        var results;
        results = [];
        for (ruleName in rules) {
          rule = rules[ruleName];
          if (rule.required || (rule.token == null)) {
            results.push(ruleName);
          }
        }
        return results;
      })());
    } else {
      enabledRules = (function() {
        var ref1, results;
        results = [];
        for (name in rules) {
          rule = rules[name];
          if (!((ref1 = rule.nondefault) != null ? ref1 : false)) {
            results.push(name);
          }
        }
        return results;
      })();
    }
    rules = _.pick(rules, _.intersection(_.keys(rules), enabledRules));
    compile = (function(_this) {
      return function(ruleName) {
        var compiledRule, regexSource;
        compiledRule = rules[ruleName] = _.clone(rules[ruleName]);
        compiledRule.compiled = true;
        regexSource = compiledRule.match.source.replace(regexRuleName, function(replacementRuleName) {
          var replacement, replacementRule;
          replacementRule = rules[replacementRuleName];
          if ((replacementRule != null ? replacementRule.match : void 0) != null) {
            if (!replacementRule.compiled) {
              compile(replacementRuleName);
            }
            replacement = replacementRule.match;
          } else {
            replacement = /[]/;
          }
          return replacement.source.replace(/(^|[^\[])\^/g, '$1');
        });
        compiledRule.match = RegExp("" + regexSource);
        compiledRule.match_i = RegExp("" + regexSource, "i");
        compiledRule.match_gim = RegExp("" + regexSource, "gim");
        return compiledRule;
      };
    })(this);
    for (ruleName in rules) {
      ref1 = rules[ruleName], match = ref1.match, compiled = ref1.compiled;
      if ((match != null) && !compiled) {
        compile(ruleName);
      }
    }
    return rules;
  };

  TrelloMarkdown.prototype._disallow = function() {
    var disallowed, ref1, state;
    state = arguments[0], disallowed = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    state = _.extend({}, state);
    state.disallowed = ((ref1 = state.disallowed) != null ? ref1 : []).concat(disallowed);
    return state;
  };

  TrelloMarkdown.lexerBlockRules = {
    newline: {
      match: /^\n/,
      token: function(arg, state, ranges) {
        var all;
        all = arg[0];
        return {
          type: 'space',
          canCondense: true,
          children: {
            text: all,
            ranges: ranges.slice(0, all)
          }
        };
      }
    },

    /*
        for i in [0..10]
          console.log(i)
     */
    code: {
      match: /^(\x20{4}[^\n]+\n*)+/,
      token: function(arg) {
        var all;
        all = arg[0];
        return {
          type: 'code',
          text: all.replace(/^ {4}/gm, '').replace(/\n+$/, '')
        };
      }
    },

    /*
    A Github Flavored Markdown feature
    ````
    for i in [0..10]
      console.log(i)
    ````
     */
    fencedCode: {
      match: /^\x20*(`{3,}|~{3,})\x20*(\S+)?\x20*\n([\s\S]+?)\s*?\1\x20*(?:\n+|$)/,
      token: function(arg) {
        var all, fence, language, text;
        all = arg[0], fence = arg[1], language = arg[2], text = arg[3];
        return {
          type: 'code',
          language: language,
          text: text
        };
      }
    },

    /*
    
    ## Heading ##
     */
    heading: {
      match: /^(\x20*(\#{2,6}|\#(?![a-fA-F0-9]{6}(?:\s|$)))\x20*)([^\n]+?)\x20*\#*\x20*(?:\n+|$)/,
      token: function(arg, state, ranges) {
        var all, beforeText, depth, text;
        all = arg[0], beforeText = arg[1], depth = arg[2], text = arg[3];
        return {
          type: 'heading',
          depth: depth.length,
          children: {
            text: text,
            ranges: ranges.slice(beforeText.length, text)
          }
        };
      }
    },

    /*
    Heading
    -------
     */
    lheading: {
      match: /^([^\n]+)\n\x20*(=|-){3,}\x20*\n*/,
      token: function(arg, state, ranges) {
        var all, char, text;
        all = arg[0], text = arg[1], char = arg[2];
        return {
          type: 'heading',
          depth: char === '=' ? 1 : 2,
          children: {
            text: text,
            ranges: ranges.slice(0, text)
          }
        };
      }
    },

    /*
    ----------
    * * * * * *
    __________
     */
    hr: {
      match: /^(?:\x20*[-*_]){3,}\x20*(?:\n|$)/,
      token: function() {
        return {
          type: 'hr'
        };
      }
    },

    /*
    > Some quote
    > more quote
    even more quote
     */
    blockquote: {
      match: /^(\x20*>[^\n]+(\n[^\n]+)*\n*)+/,
      token: function(arg, state, ranges) {
        var all, blockquoteRanges, quote, subtractSpans;
        all = arg[0];
        subtractSpans = [];
        quote = all.replace(/^ *> ?/gm, function(match, index) {
          var i, len, ref1, span;
          ref1 = ranges.slice(index, match).spans;
          for (i = 0, len = ref1.length; i < len; i++) {
            span = ref1[i];
            subtractSpans.push(span);
          }
          return '';
        });
        blockquoteRanges = ranges.subtract(new SelectionRange(subtractSpans));
        return [{
            type: "blockquote_start"
          }].concat(slice.call(this.blockLex(quote, state, blockquoteRanges)), [{
            type: "blockquote_end"
          }]);
      }
    },

    /*
    - item 1
    - item 2
     */
    num: {
      match: /(?:\d+\.)/
    },
    dash: {
      match: /(?:[*+-])/
    },
    bullet: {
      match: /(?:dash|num)/
    },
    item: {
      match: /^(\x20*)(bullet)\x20[^\n]*(?:\n(?!\1bullet\x20)[^\n]*)*/
    },
    list: {
      match: /^(\x20*)(?:(dash)\x20[\s\S]+?(?:\nhr|\n{2,}(?=def|(?!\x20))(?!\1dash\x20)\n*|\s*$)|(num)\x20[\s\S]+?(?:\nhr|\n{2,}(?=def|(?!\x20))(?!\1num\x20)\n*|\s*$))/,
      token: function(arg, state, ranges) {
        var all, dash_bullet, index, itemCount, itemsTokens, next, num_bullet, spaces, tag;
        all = arg[0], spaces = arg[1], dash_bullet = arg[2], num_bullet = arg[3];
        next = false;
        index = 0;
        itemsTokens = [];
        tag = dash_bullet != null ? "ul" : "ol";
        itemCount = all.match(this.lexerBlockRules.item.match_gim).length;
        all.replace(this.lexerBlockRules.item.match_gim, (function(_this) {
          return function() {
            var all, captures, i, item, itemIndex, itemRanges, itemRangesOrig, loose, space;
            item = arguments[0], captures = 4 <= arguments.length ? slice.call(arguments, 1, i = arguments.length - 2) : (i = 1, []), itemIndex = arguments[i++], all = arguments[i++];
            itemRanges = ranges.slice(itemIndex, item);
            loose = next || /\n\n(?!\s*$)/.test(item);
            if (index !== itemCount - 1) {
              next = item[item.length - 1] === '\n';
              loose || (loose = next);
            }
            space = item.length;
            item = item.replace(/^\x20*([*+-]|\d+\.)\x20+/, function(all) {
              itemRanges = itemRanges.subtract(itemRanges.slice(0, all));
              return "";
            });
            space -= item.length;
            itemRangesOrig = itemRanges.clone();
            item = item.replace(RegExp("^\\x20{1," + space + "}", "gm"), function(match, index) {
              itemRanges = itemRanges.subtract(itemRangesOrig.slice(index, match));
              return "";
            });
            itemsTokens.push([{
                type: 'list_item_start',
                tag: tag,
                condense: !loose,
                index: index
              }].concat(slice.call(_this.blockLex(item, _this._disallow(state, 'top'), itemRanges)), [{
                type: 'list_item_end'
              }]));
            index++;
            return "";
          };
        })(this));
        return [{
            type: 'list_start',
            tag: tag
          }].concat(slice.call(_.flatten(itemsTokens)), [{
            type: 'list_end'
          }]);
      }
    },

    /*
    trello [1] bar [2]
    
    [1]: http://trello.com
    [2]: <https://fogcreek.com> "Fog Creek Software"
     */
    def: {
      whenAllowed: 'top',
      match: /^\x20*\[([^\]]+)\]:\x20*<?([^\s>]+)>?(?:\x20+["(]([^\n]+)[")])?\x20*(?:\n+|$)/,
      token: function(arg, arg1) {
        var all, ref, references, title, url;
        all = arg[0], ref = arg[1], url = arg[2], title = arg[3];
        references = arg1.references;
        if (references != null) {
          references.set(ref, {
            url: url,
            title: title
          });
        }
        return null;
      }
    },
    blockAtMention: {
      nondefault: true,
      match: /^@([a-z0-9_]+)(?=\n|$)/,
      token: function(arg) {
        var all, username;
        all = arg[0], username = arg[1];
        return {
          type: 'atMention',
          username: username
        };
      }
    },
    paragraph: {
      whenAllowed: 'top',
      match: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|def|blockAtMention))+)\n*/,
      token: function(arg, state, ranges) {
        var all, content, text;
        all = arg[0], content = arg[1];
        text = content.replace(/\n$/, '');
        return {
          type: 'text',
          children: {
            text: text,
            ranges: ranges.slice(0, text)
          }
        };
      }
    },
    text: {
      required: true,
      match: /^[^\n]+/,
      token: function(arg, state, ranges) {
        var all;
        all = arg[0];
        return {
          type: 'text',
          canCondense: true,
          children: {
            text: all,
            ranges: ranges.slice(0, all)
          }
        };
      }
    },
    error: {
      required: true,
      match: /^[\s\S]+/,
      token: function(arg) {
        var all;
        all = arg[0];
        throw Error("invalid block input " + all);
      }
    }
  };

  _linkToken = function(arg) {
    var image, ranges, text, title, token, url;
    image = arg.image, text = arg.text, url = arg.url, title = arg.title, ranges = arg.ranges;
    token = {
      title: title,
      url: url
    };
    if (image) {
      token.type = "image";
      token.text = text;
    } else {
      token.type = "link";
      token.children = {
        text: text,
        ranges: ranges.slice(1, text)
      };
    }
    return token;
  };

  TrelloMarkdown.lexerInlineRules = {
    escape: {
      required: true,
      match: /^\\([\\`*{}\[\]()\#+\-.!_>~|@:])/,
      token: function(arg) {
        var all, escaped;
        all = arg[0], escaped = arg[1];
        return {
          type: 'text',
          text: escaped
        };
      }
    },
    tld: {
      match: /(?:ac|ad|aero|ae|af|ag|ai|al|am|an|ao|aq|arpa|ar|asia|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|biz|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|cat|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|coop|com|co|cr|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|edu|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gov|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|info|int|in|io|iq|ir|is|it|je|jm|jobs|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mil|mk|ml|mm|mn|mobi|mo|mp|mq|mr|ms|mt|museum|mu|mv|mw|mx|my|mz|name|na|nc|net|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|org|pa|pe|pf|pg|ph|pk|pl|pm|pn|pro|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tel|tf|tg|th|tj|tk|tl|tm|tn|to|tp|travel|tr|tt|tv|tw|tz|ua|ug|uk|um|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw)/
    },
    bareLink: {
      match: /([^\s\x00-\x2c\x2e-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+\.)+(?:tld)/
    },
    autolink: {
      match: /^<(?:(email)|(url|bareLink))>/,
      token: function(arg) {
        var all, email, url;
        all = arg[0], email = arg[1], url = arg[2];
        if (email != null) {
          return {
            type: "mailto",
            email: email
          };
        } else if (/^[\w-]+:/.test(url)) {
          return {
            type: "link",
            url: url
          };
        } else {
          return {
            type: "link",
            url: "http://" + url,
            text: url
          };
        }
      }
    },
    email: {
      match: /^[-a-z0-9\+\._'%]+@[a-z0-9-\.]+\.[a-z]{2,}/,
      token: function(arg) {
        var email;
        email = arg[0];
        return {
          type: "mailto",
          email: email
        };
      }
    },
    inside: {
      match: /(?:\[[^\]\[]*\]|[^\]\[]|\](?=[^\[]*\]))*/
    },
    href: {
      match: /\s*<?((?:[^\s\(\)]?(?:\([^\s()<>]*\)|\()?)+)>?(?:\s+['"]([\s\S]*?)['"])?\s*/
    },
    emailLink: {
      match: /^\[(inside)\]\((email)\)/,
      token: function(arg) {
        var all, email, text;
        all = arg[0], text = arg[1], email = arg[2];
        return {
          type: "mailto",
          email: email,
          text: text
        };
      }
    },
    link: {
      match: /^\[(inside)\]\(href\)/,
      token: function(arg, state, ranges) {
        var all, text, title, url;
        all = arg[0], text = arg[1], url = arg[2], title = arg[3];
        return _linkToken({
          text: text,
          url: url,
          title: title,
          ranges: ranges
        });
      }
    },
    image: {
      match: /^(!)\[(inside)\]\(href\)/,
      token: function(arg, state, ranges) {
        var all, image, text, title, url;
        all = arg[0], image = arg[1], text = arg[2], url = arg[3], title = arg[4];
        return _linkToken({
          image: true,
          text: text,
          url: url,
          title: title,
          ranges: ranges
        });
      }
    },
    reflink: {
      match: /^(!?)\[(inside)\]\s*\[([^\]]*)\]/,
      token: function(arg, state, ranges) {
        var all, image, ref, ref1, reference, text;
        all = arg[0], image = arg[1], text = arg[2], reference = arg[3];
        if ((ref = (ref1 = state.references) != null ? ref1.get(reference || text) : void 0) == null) {
          return false;
        } else {
          return _linkToken({
            image: image,
            text: text,
            url: ref.url,
            title: ref.title,
            ranges: ranges
          });
        }
      }
    },
    nolink: {
      match: /^(!?)\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
      token: function(arg, state, ranges) {
        var all, image, ref, ref1, text;
        all = arg[0], image = arg[1], text = arg[2];
        if ((ref = (ref1 = state.references) != null ? ref1.get(text) : void 0) == null) {
          return false;
        } else {
          return _linkToken({
            image: image,
            text: text,
            url: ref.url,
            title: ref.title,
            ranges: ranges
          });
        }
      }
    },
    url: {
      whenAllowed: 'autolink',
      match: /^((?:[\w-]+:\/\/|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]|\([^\s()<>]*\))+(?:\([^\s()<>]*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’])|(?:bareLink)\b)/,
      token: function(arg) {
        var all, parts, protocol, rest, url, withLowerCaseProtocol;
        url = arg[0];
        parts = /^([\w-]+):\/\/([\s\S]*)$/.exec(url);
        if (parts) {
          all = parts[0], protocol = parts[1], rest = parts[2];
          withLowerCaseProtocol = (protocol.toLowerCase()) + "://" + rest;
          if (withLowerCaseProtocol === url) {
            return {
              type: "link",
              url: withLowerCaseProtocol
            };
          } else {
            return {
              type: "link",
              url: withLowerCaseProtocol,
              text: url
            };
          }
        } else {
          return {
            type: "link",
            url: "http://" + url,
            text: url
          };
        }
      }
    },
    strong: {
      match: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
      token: function(arg, state, ranges) {
        var all, starred, text, underscored;
        all = arg[0], underscored = arg[1], starred = arg[2];
        text = underscored != null ? underscored : starred;
        return [{
            type: 'strong_start'
          }].concat(slice.call(this.inlineLex(text, state, ranges.slice(2, text))), [{
            type: 'strong_end'
          }]);
      }
    },
    em: {
      match: /^\b_([\s\S]*?[^_])_(?!_)\b|^\*([\s\S]*?[^*])\*(?!\*)/,
      token: function(arg, state, ranges) {
        var all, starred, text, underscored;
        all = arg[0], underscored = arg[1], starred = arg[2];
        text = underscored != null ? underscored : starred;
        return [{
            type: 'em_start'
          }].concat(slice.call(this.inlineLex(text, state, ranges.slice(1, text))), [{
            type: 'em_end'
          }]);
      }
    },
    strikethrough: {
      match: /^~~([\s\S]+?)~~/,
      token: function(arg, state, ranges) {
        var all, struckthrough, text;
        all = arg[0], struckthrough = arg[1];
        text = struckthrough;
        return [{
            type: 'strikethrough_start'
          }].concat(slice.call(this.inlineLex(text, state, ranges.slice(2, text))), [{
            type: 'strikethrough_end'
          }]);
      }
    },
    code: {
      match: /^(`+)\s*((?:\1`+|[\s\S])+?)\s*\1(?!`)/,
      token: function(arg) {
        var all, code, ticks;
        all = arg[0], ticks = arg[1], code = arg[2];
        return {
          type: 'code',
          text: code
        };
      }
    },
    "break": {
      match: /^\x20*\n(?!\s*$)/,
      token: function() {
        return {
          type: 'break'
        };
      }
    },
    atMention: {
      match: /^@([a-z0-9_]+)/,
      token: function(arg) {
        var all, username;
        all = arg[0], username = arg[1];
        return {
          type: 'atMention',
          username: username
        };
      }
    },
    emoji: {
      match: /^:([a-z0-9_+-]+):/,
      token: function(arg) {
        var all, emoji;
        all = arg[0], emoji = arg[1];
        return {
          type: 'emoji',
          emoji: emoji
        };
      }
    },
    hashtag: {
      nondefault: true,
      match: /^\#([\S]+)/,
      token: function(arg) {
        var all, tag;
        all = arg[0], tag = arg[1];
        return {
          type: 'text',
          text: all
        };
      }
    },
    hexCode: {
      match: /\#[a-fA-F0-9]{6}/
    },
    hexNum: {
      match: /(?:25[0-5]|2[0-4]\d|1?\d{1,2})/
    },
    decimalPercent: {
      match: /(?:0|1(?:\.0)?|0?\.\d+)/
    },
    colorChip: {
      match: /^(hexCode|(?:rgb\(hexNum,\x20*hexNum,\x20*hexNum\))|(?:rgba\((?:hexNum,\x20*){3}decimalPercent\)))(?:(?!\w)|$)/,
      token: function(arg) {
        var color;
        color = arg[0];
        return {
          type: 'colorChip',
          color: color
        };
      }
    },
    text: {
      required: true,
      match: /^[\s\S]+?(?:\w[@\#:][\x20\S]+?)?(?=[\\<!\[_*`~]|\x20*\n|[@:\#]|(?:rgba?\()|(?:\b(?:url|email))|$)/,
      token: function(arg) {
        var all;
        all = arg[0];
        return {
          type: 'text',
          text: all
        };
      }
    },
    error: {
      required: true,
      match: /^[\s\S]+/,
      token: function(arg) {
        var all;
        all = arg[0];
        throw Error("invalid inline input " + all);
      }
    }
  };

  parseAtMention = function(arg) {
    var isMe, ref1, userFullName, username;
    username = arg.username;
    if (this.options.lookupMember != null) {
      ref1 = this.options.lookupMember(username, this.state), userFullName = ref1[0], isMe = ref1[1];
      if (userFullName != null) {
        return this.html('span', "@" + username, {
          attrs: {
            "class": "atMention" + (isMe ? " me" : ""),
            "title": "" + userFullName
          }
        });
      }
    }
    return this.text("@" + username);
  };

  TrelloMarkdown.prototype.parseBlockOutput = {
    space: function() {
      return '';
    },
    hr: function() {
      return this.htmln('hr', null);
    },
    heading: function(arg) {
      var children, depth;
      depth = arg.depth, children = arg.children;
      return this.htmln("h" + depth, this.children(children));
    },
    blockquote_start: function() {
      return this.htmln('blockquote', this.process('blockquote_end'), {
        newlineAfterTag: true
      });
    },
    list_start: function(arg) {
      var tag;
      tag = arg.tag;
      return this.htmln(tag, this.process('list_end'), {
        newlineAfterTag: true
      });
    },
    list_item_start: function(arg) {
      var condense;
      condense = arg.condense;
      return this.htmln('li', this.process('list_item_end', condense));
    },
    text: function(arg) {
      var children;
      children = arg.children;
      return this.htmln('p', this.children(children));
    },
    code: function(arg) {
      var text;
      text = arg.text;
      return this.htmln('code', this.text(text), {
        preTag: '<pre>',
        postTag: '</pre>'
      });
    },
    atMention: parseAtMention
  };

  TrelloMarkdown.prototype.parseInlineOutput = {
    text: function(arg) {
      var text;
      text = arg.text;
      return this.text(text);
    },
    strong_start: function() {
      return this.html('strong', this.process('strong_end'));
    },
    em_start: function() {
      return this.html('em', this.process('em_end'));
    },
    strikethrough_start: function() {
      return this.html('del', this.process('strikethrough_end'));
    },
    code: function(arg) {
      var text;
      text = arg.text;
      return this.html('code', this.escape(text));
    },
    "break": function() {
      return this.html('br', null);
    },
    link: function(arg) {
      var children, content, rel, shouldOpenInNewTab, target, text, title, url;
      url = arg.url, text = arg.text, title = arg.title, children = arg.children;
      content = children != null ? this.children(children) : this.escape(text != null ? text : url);
      shouldOpenInNewTab = this.options.shouldOpenLinkInNewTab(url);
      target = shouldOpenInNewTab ? "_blank" : null;
      rel = shouldOpenInNewTab ? "noreferrer nofollow" : null;
      return this.html('a', content, {
        attrs: {
          href: url,
          title: title,
          target: target,
          rel: rel
        }
      });
    },
    mailto: function(arg) {
      var email, text;
      email = arg.email, text = arg.text;
      return this.html('a', this.escape(text != null ? text : email), {
        attrs: {
          href: "mailto:" + email
        }
      });
    },
    image: function(arg) {
      var text, title, url;
      url = arg.url, title = arg.title, text = arg.text;
      return this.html('img', null, {
        attrs: {
          src: url,
          alt: text,
          title: title
        }
      });
    },
    atMention: parseAtMention,
    emoji: function(arg) {
      var base, emoji, emojiUrl;
      emoji = arg.emoji;
      emojiUrl = typeof (base = this.options).lookupEmoji === "function" ? base.lookupEmoji(emoji, this.state) : void 0;
      if (emojiUrl != null) {
        return this.html('img', null, {
          attrs: {
            src: emojiUrl,
            title: emoji,
            "class": 'emoji'
          }
        });
      } else {
        return this.text(":" + emoji + ":");
      }
    },
    colorChip: function(arg) {
      var chipDiv, color;
      color = arg.color;
      chipDiv = this.html('span', '', {
        attrs: {
          "class": 'mkdwn-color-chip',
          style: "background-color:" + color + ";"
        }
      });
      return this.html('span', color.concat(chipDiv));
    }
  };

  TrelloMarkdown.prototype.parseBlockOutputText = {
    space: function() {
      return this.plaintextn('');
    },
    hr: function() {
      return this.plaintextn('');
    },
    heading: function(arg) {
      var children, depth;
      depth = arg.depth, children = arg.children;
      return this.plaintextn(this.textChildren(children));
    },
    blockquote_start: function() {
      return this.plaintext(this.textProcess('blockquote_end'));
    },
    list_start: function(arg) {
      var line, tag;
      tag = arg.tag;
      return ((function() {
        var i, len, ref1, results;
        ref1 = this.textProcess('list_end').split('\n');
        results = [];
        for (i = 0, len = ref1.length; i < len; i++) {
          line = ref1[i];
          results.push(this.plaintextn(" " + line));
        }
        return results;
      }).call(this)).join("");
    },
    list_item_start: function(arg) {
      var bullet, condense, index, tag;
      tag = arg.tag, index = arg.index, condense = arg.condense;
      bullet = tag === 'ol' ? (index + 1) + "." : "*";
      return this.plaintextn(bullet + " " + (this.textProcess('list_item_end', condense)));
    },
    text: function(arg) {
      var children;
      children = arg.children;
      return this.plaintextn((this.textChildren(children)) + "\n");
    },
    code: function(arg) {
      var text;
      text = arg.text;
      return this.plaintextn(text);
    },
    atMention: function(arg) {
      var username;
      username = arg.username;
      return this.plaintextn(username);
    }
  };

  TrelloMarkdown.prototype.parseInlineOutputText = {
    text: function(arg) {
      var text;
      text = arg.text;
      return this.plaintext(text);
    },
    strong_start: function() {
      return this.plaintext(this.textProcess('strong_end'));
    },
    em_start: function() {
      return this.plaintext(this.textProcess('em_end'));
    },
    strikethrough_start: function() {
      return this.plaintext('~~' + this.textProcess('strikethrough_end') + '~~');
    },
    code: function(arg) {
      var text;
      text = arg.text;
      return this.plaintext(text);
    },
    "break": function() {
      return this.plaintext("\n");
    },
    link: function(arg) {
      var children, text, title, url;
      url = arg.url, text = arg.text, title = arg.title, children = arg.children;
      if (children != null) {
        return this.plaintext((this.textChildren(children)) + " (" + url + ")");
      } else if (text != null) {
        return this.plaintext(text + " (" + url + ")");
      } else {
        return this.plaintext(url);
      }
    },
    mailto: function(arg) {
      var email, text;
      email = arg.email, text = arg.text;
      if (text != null) {
        return this.plaintext(text + " (" + email + ")");
      } else {
        return this.plaintext(email);
      }
    },
    image: function(arg) {
      var text, title, url;
      url = arg.url, title = arg.title, text = arg.text;
      if (title != null) {
        return this.plaintext(title);
      } else {
        return this.plaintext("");
      }
    },
    atMention: function(arg) {
      var username;
      username = arg.username;
      return this.plaintext(username);
    },
    emoji: function(arg) {
      var emoji;
      emoji = arg.emoji;
      return this.plaintext(":" + emoji + ":");
    },
    colorChip: function(arg) {
      var color;
      color = arg.color;
      return this.plaintext(color);
    }
  };

  TrelloMarkdown.prototype.lex = function(rules, text, state, ranges) {
    var all, allTokens, capture, i, index, j, len, len1, match_i, rangesOrig, ref1, ref2, ref3, rule, ruleTokens, start, stop, t, token, tokenRanges, whenAllowed;
    if (state == null) {
      state = {};
    }
    if (state.locations == null) {
      state.locations = [];
    }
    rangesOrig = ranges.clone();
    text = text.replace(/^\x20+$/gm, function(match, index) {
      ranges = ranges.subtract(rangesOrig.slice(index, match));
      return '';
    });
    allTokens = [];
    index = 0;
    while (text) {
      for (rule in rules) {
        ref1 = rules[rule], match_i = ref1.match_i, token = ref1.token, whenAllowed = ref1.whenAllowed;
        if (!(token != null)) {
          continue;
        }
        if ((whenAllowed != null) && (state.disallowed != null) && indexOf.call(state.disallowed, whenAllowed) >= 0) {
          continue;
        }
        if ((capture = match_i.exec(text)) != null) {
          all = capture[0];
          tokenRanges = ranges.slice(index, all);
          ruleTokens = token.call(this, capture, state, tokenRanges);
          if (ruleTokens === false) {
            continue;
          }
          if (ruleTokens != null) {
            if (!_.isArray(ruleTokens)) {
              ruleTokens = [ruleTokens];
            }
            for (i = 0, len = ruleTokens.length; i < len; i++) {
              t = ruleTokens[i];
              allTokens.push(t);
            }
          }
          if (all.length === 0) {
            throw Error("infinite loop");
          }
          text = text.substr(all.length);
          ref2 = tokenRanges.spans;
          for (j = 0, len1 = ref2.length; j < len1; j++) {
            ref3 = ref2[j], start = ref3[0], stop = ref3[1];
            state.locations.push({
              start: start,
              stop: stop,
              rule: rule
            });
          }
          index += all.length;
          break;
        }
      }
    }
    return allTokens;
  };

  TrelloMarkdown.prototype._expandChildren = function(tokens, state, condense) {
    var children, childrenState, hasType, i, index, j, lastToken, len, len1, processedTokens, ranges, ref1, rest, text, token;
    if (tokens.length === 0) {
      return;
    }
    if (condense) {
      lastToken = tokens[0], rest = 2 <= tokens.length ? slice.call(tokens, 1) : [];
      processedTokens = [lastToken];
      hasType = function(token, type) {
        return token.canCondense && (token.children != null) && token.type === type;
      };
      for (index = i = 0, len = rest.length; i < len; index = ++i) {
        token = rest[index];
        if (hasType(lastToken, 'text') && (hasType(token, 'text') || (hasType(token, 'space') && hasType(rest[index + 1], 'text')))) {
          lastToken.children = {
            text: lastToken.children.text + token.children.text,
            ranges: new SelectionRange(slice.call(lastToken.children.ranges.spans).concat(slice.call(token.children.ranges.spans)))
          };
        } else {
          processedTokens.push(token);
          lastToken = token;
        }
      }
    } else {
      processedTokens = tokens;
    }
    for (j = 0, len1 = processedTokens.length; j < len1; j++) {
      token = processedTokens[j];
      if (!(token.children != null)) {
        continue;
      }
      ref1 = token.children, text = ref1.text, ranges = ref1.ranges;
      childrenState = token.type === 'link' ? this._disallow(state, 'autolink') : state;
      children = this.inlineLex(text, childrenState, ranges);
      this._expandChildren(children, childrenState);
      token.children = children;
    }
  };

  TrelloMarkdown.prototype.blockLex = function(text, state, ranges, expandChildren) {
    var tokens;
    if (ranges == null) {
      ranges = SelectionRange.fromString(text);
    }
    if (state.references == null) {
      state.references = {
        map: {},
        set: function(key, data) {
          return this.map[key.toLowerCase()] = data;
        },
        get: function(key) {
          return this.map[key.toLowerCase()];
        }
      };
    }
    tokens = this.lex(this.lexerBlockRules, text, state, ranges);
    if (expandChildren) {
      this._expandChildren(tokens, state, true);
    }
    return tokens;
  };

  TrelloMarkdown.prototype.inlineLex = function(text, state, ranges, expandChildren) {
    var tokens;
    if (ranges == null) {
      ranges = SelectionRange.fromString(text);
    }
    tokens = this.lex(this.lexerInlineRules, text, state, ranges);
    if (expandChildren) {
      this._expandChildren(tokens, state, true);
    }
    return tokens;
  };

  TrelloMarkdown.prototype.parse = function(rules, tokens, state) {
    var outputterContext;
    outputterContext = {
      options: this.options,
      state: state,
      index: 0,
      next: function() {
        return this.current = tokens[this.index++];
      },
      process: function(stopType, condenseText) {
        var output, outputter, token;
        output = (function() {
          var results;
          results = [];
          while (((token = this.next()) != null) && token.type !== stopType) {
            if (condenseText && token.type === 'text') {
              results.push(outputterContext.children(token.children));
            } else {
              outputter = rules[token.type];
              if (outputter != null) {
                results.push(outputter.call(outputterContext, token));
              } else {
                throw Error("invalid token type " + token.type);
              }
            }
          }
          return results;
        }).call(this);
        return output.join('');
      },
      textProcess: function(stopType, condenseText) {
        var output, outputter, token;
        output = (function() {
          var results;
          results = [];
          while (((token = this.next()) != null) && token.type !== stopType) {
            if (condenseText && token.type === 'text') {
              results.push(outputterContext.textChildren(token.children));
            } else {
              outputter = rules[token.type];
              if (outputter != null) {
                results.push(outputter.call(outputterContext, token));
              } else {
                throw Error("invalid token type " + token.type);
              }
            }
          }
          return results;
        }).call(this);
        return output.join('');
      },
      children: (function(_this) {
        return function(tokens, text) {
          return _this.parseInline(tokens, state);
        };
      })(this),
      textChildren: (function(_this) {
        return function(tokens, text) {
          return _this.parseInlineText(tokens, state);
        };
      })(this),
      escape: function(text) {
        if (text == null) {
          text = "undefined";
        }
        return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      },
      safeUrl: function(url) {
        if (/^\//.test(url)) {
          return url;
        }
        if (/^[^\/]*:/.test(url)) {
          return url.replace(/^[^:]*/, function(protocol) {
            protocol = protocol.toLowerCase().replace(/[^\w-]/g, "");
            if (!protocol || /script|data/.test(protocol)) {
              return "http";
            } else {
              return protocol;
            }
          });
        } else {
          return "http://" + url;
        }
      },
      text: function(text) {
        return this.escape(text);
      },
      plaintext: function(text) {
        return text;
      },
      plaintextn: function(text) {
        return this.plaintext(text) + "\n";
      },
      html: function(tag, content, arg) {
        var attrs, name, newlineAfterTag, output, postTag, preTag, ref1, value;
        ref1 = arg != null ? arg : {}, attrs = ref1.attrs, newlineAfterTag = ref1.newlineAfterTag, preTag = ref1.preTag, postTag = ref1.postTag;
        output = "";
        if (preTag != null) {
          output += preTag;
        }
        output += "<" + tag;
        if (attrs != null) {
          for (name in attrs) {
            value = attrs[name];
            if (!(value != null)) {
              continue;
            }
            if (name === "src" || name === "href") {
              value = this.safeUrl(value);
            }
            output += " " + (name + "=\"" + (this.escape(value)) + "\"");
          }
        }
        output += ">";
        if (newlineAfterTag) {
          output += "\n";
        }
        if (content != null) {
          output += content + ("</" + tag + ">");
          if (postTag != null) {
            output += postTag;
          }
        }
        return output;
      },
      htmln: function() {
        var args;
        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        return this.html.apply(this, args) + "\n";
      }
    };
    return outputterContext.process();
  };

  TrelloMarkdown.prototype.parseBlocks = function(blockTokens, state) {
    if (state == null) {
      state = {};
    }
    return this.parse(this.parseBlockOutput, blockTokens, state);
  };

  TrelloMarkdown.prototype.parseInline = function(inlineTokens, state) {
    if (state == null) {
      state = {};
    }
    return this.parse(this.parseInlineOutput, inlineTokens, state);
  };

  TrelloMarkdown.prototype.parseBlocksText = function(blockTokens, state) {
    if (state == null) {
      state = {};
    }
    return this.parse(this.parseBlockOutputText, blockTokens, state);
  };

  TrelloMarkdown.prototype.parseInlineText = function(inlineTokens, state) {
    if (state == null) {
      state = {};
    }
    return this.parse(this.parseInlineOutputText, inlineTokens, state);
  };

  _prepareText = function(text) {
    return text.replace(/\r\n|\r/g, '\n').replace(/\t/g, '    ').replace(/\u00a0/g, ' ').replace(/\u2424/g, '\n');
  };

  TrelloMarkdown.prototype.format = function(text, state) {
    var output, tokens;
    if (state == null) {
      state = {};
    }
    text = _prepareText(text);
    output = this.options.inlineOnly ? this.formatInline(text, state) : (tokens = this.blockLex(text, state, null, true), this.parseBlocks(tokens, state));
    return {
      output: output,
      locations: state.locations
    };
  };

  TrelloMarkdown.prototype.formatInline = function(text, state, ranges) {
    if (state == null) {
      state = {};
    }
    if (ranges == null) {
      ranges = null;
    }
    return this.parseInline(this.inlineLex(text, state, ranges, true), state);
  };

  TrelloMarkdown.prototype.text = function(text, state) {
    var output, tokens;
    if (state == null) {
      state = {};
    }
    text = _prepareText(text);
    output = this.options.inlineOnly ? this.textInline(text, state) : (tokens = this.blockLex(text, state, null, true), this.parseBlocksText(tokens, state));
    output = output.replace(/^\s*|\s*$/g, '').replace(/\n(\x20*\n)+/g, '\n\n');
    return {
      output: output,
      locations: state.locations
    };
  };

  TrelloMarkdown.prototype.textInline = function(text, state, ranges) {
    if (state == null) {
      state = {};
    }
    if (ranges == null) {
      ranges = null;
    }
    return this.parseInlineText(this.inlineLex(text, state, ranges, true), state);
  };

  TrelloMarkdown.prototype.analyze = function(text, state) {
    if (state == null) {
      state = {};
    }
    text = _prepareText(text);
    if (this.options.inlineOnly) {
      this.inlineLex(text, state);
    } else {
      this.blockLex(text, state, null, true);
    }
    return state.locations;
  };

  TrelloMarkdown.prototype.getMatches = function(text, rules, fxSet) {
    var i, item, len, locations, matchtext, output, res, rule;
    if (fxSet == null) {
      fxSet = {};
    }
    locations = this.analyze(text);
    res = {};
    for (rule in rules) {
      res[rule] = [];
    }
    for (i = 0, len = locations.length; i < len; i++) {
      item = locations[i];
      if (item.rule in rules) {
        matchtext = text.slice(item.start, item.stop);
        output = !(item.rule in fxSet) ? matchtext : fxSet[item.rule](matchtext);
        res[item.rule].push(output);
      }
    }
    return res;
  };

  TrelloMarkdown.prototype.replace = function(text, rules, fxReplace) {
    var i, len, locations, offsetModified, output, ref1, rule, start, stop;
    locations = _.sortBy(this.analyze(text), function(arg) {
      var start;
      start = arg.start;
      return -start;
    });
    offsetModified = text.length;
    output = text;
    for (i = 0, len = locations.length; i < len; i++) {
      ref1 = locations[i], rule = ref1.rule, start = ref1.start, stop = ref1.stop;
      if (indexOf.call(rules, rule) >= 0 && stop <= offsetModified) {
        output = [
          output.slice(0, start), fxReplace(output.slice(start, stop), {
            rule: rule,
            options: this.options
          }), output.slice(stop)
        ].join("");
        offsetModified = start;
      }
    }
    return output;
  };

  return TrelloMarkdown;

})();


/*
A "SelectionRange" represents the sections of the original markdown input that
are currently being operated on

The impetus for having something like this is to be able to identify where in
a markdown string certain types of tokens (e.g. @mentions)
exist (Because of code blocks, escaping, and other contexts, it'd be very
difficult to do this with simple regular expressions)

A selection range can include multiple sections of text, which is necessary when
you have an input string like this:

"> test\n> @mention\n> test"
   ^^^^^^  ^^^^^^^^    ^^^^

The ^ denote the parts of the string that are being operated on when lexing the
paragraph that is "inside" the block quote; the sections aren't contiguous, and
is represented by 3 spans, 2-7, 9-18, 20-24

By the time the "paragraph" rule is reached, it's operating on a string that
looks like this:

"test\n@mention\ntest"

... and if we don't know which sections of the original source we're operating
on, we won't be able to report where the @mention occurs
 */

SelectionRange = (function() {
  var _convertSubToSource, _slice, _subtract;

  function SelectionRange(spans1) {
    this.spans = spans1 != null ? spans1 : [];
  }

  SelectionRange.fromString = function(s) {
    return new SelectionRange([[0, s.length]]);
  };

  SelectionRange.prototype.clone = function() {
    return new SelectionRange(_.clone(this.spans));
  };

  _subtract = function(spansOriginal, subSpans) {
    var newSpans, nextSpan, ref1, spanEnd, spanStart, spans, subEnd, subIndex, subStart;
    newSpans = [];
    spans = _.clone(spansOriginal);
    subIndex = 0;
    while (spans.length) {
      nextSpan = spans.shift();
      if (subIndex >= subSpans.length) {
        newSpans.push(nextSpan);
      } else {
        spanStart = nextSpan[0], spanEnd = nextSpan[1];
        ref1 = subSpans[subIndex], subStart = ref1[0], subEnd = ref1[1];
        if (subEnd <= spanStart) {
          spans.unshift(nextSpan);
          subIndex++;
        } else if (subStart >= spanEnd) {
          newSpans.push(nextSpan);
        } else if (subStart <= spanStart && subEnd < spanEnd) {
          spans.unshift([subEnd, spanEnd]);
          subIndex++;
        } else if (subStart <= spanStart && subEnd >= spanEnd) {

        } else if (subStart > spanStart && subEnd < spanEnd) {
          newSpans.push([spanStart, subStart]);
          spans.unshift([subEnd, spanEnd]);
          subIndex++;
        } else if (subStart > spanStart && subEnd >= spanEnd) {
          newSpans.push([spanStart, subStart]);
        }
      }
    }
    return newSpans;
  };

  SelectionRange.prototype.subtract = function(range) {
    return new SelectionRange(_subtract(this.spans, range.spans));
  };

  _convertSubToSource = function(spans, positionSub) {
    var i, len, ref1, spanLength, startSource, stopSource;
    for (i = 0, len = spans.length; i < len; i++) {
      ref1 = spans[i], startSource = ref1[0], stopSource = ref1[1];
      spanLength = stopSource - startSource;
      if (positionSub <= spanLength) {
        return startSource + positionSub;
      } else {
        positionSub -= spanLength;
      }
    }
    throw Error("invalid position");
  };

  _slice = function(spans, startSub, stopSub) {
    var spanAfterStop, spanBeforeStart, startSource, stopSource;
    startSource = _convertSubToSource(spans, startSub);
    stopSource = _convertSubToSource(spans, stopSub);
    spanBeforeStart = [0, startSource];
    spanAfterStop = [stopSource, _.last(spans)[1]];
    return _subtract(spans, [spanBeforeStart, spanAfterStop]);
  };

  SelectionRange.prototype.slice = function(startSub, stopSubOrString) {
    if (_.isString(stopSubOrString)) {
      return this.slice(startSub, startSub + stopSubOrString.length);
    }
    return new SelectionRange(_slice(this.spans, startSub, stopSubOrString));
  };

  return SelectionRange;

})();

module.exports = TrelloMarkdown;
